<ap-panel type="primary" title="{{ 'conversational.chat.disclaimer.title' | apContent }}">
    <p ap-panel-body><ap-content key="conversational.chat.disclaimer.message"></ap-content></p>
</ap-panel>
